import TextField from "../components/common/TextField";
import { useFormik } from "formik";
import { loginSchema } from "../utils/validations";
import Button from "../components/common/Button";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { AccountState, LoginData, VerificationTokenType } from "../types";
import {
  setUser,
  useGenerateMutation,
  useLoginMutation,
  useTypedDispatch,
  useTypedSelector,
} from "../store";
import Logo from "../components/common/Logo";

const Login = () => {
  const [generateCode] = useGenerateMutation();
  const userSession = useTypedSelector((state) => state.session.user);
  const [login, { isLoading }] = useLoginMutation();
  const navigate = useNavigate();
  const dispatch = useTypedDispatch();

  const handleSubmitForm = async (values: LoginData) => {
    const result = await login(values);
    if (!result.error && result.data) {
      if (
        result.data.accountState === AccountState.PENDING_EMAIL_VERIFICATION
      ) {
        const body = {
          email: result.data.email,
          type: VerificationTokenType.VERIFY_EMAIL,
        };
        await generateCode(body);
        navigate(`/auth/verify-code?email=${result.data.email}`); // TODO : make routes in config no hard code
      } else {
        dispatch(setUser(result.data));
        navigate("/restaurants"); // TODO : make routes in config no hard code
      }
    }
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormik<LoginData>({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: loginSchema,
    onSubmit: handleSubmitForm,
  });

  if (userSession?.accessToken) {
    return <Navigate to="/" />;
  }

  return (
    <div className="w-full flex min-h-screen">
      <div className="w-full md:w-1/2 h-full flex flex-col items-center mt-12 p-4 border-r">
        <form className="mx-auto w-full md:w-3/5 flex flex-col items-center gap-3">
          <Logo />
          <div className="text-start w-full text-xl mt-4 font-semibold">
            Connexion
          </div>
          <TextField
            id="email"
            value={values.email || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            placeholder="Email"
          />
          <TextField
            id="password"
            value={values.password || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            placeholder="Mot de passe"
            hideable
          />
          <Button
            className="w-1/2 justify-center font-bold py-2 bg-primary rounded text-white"
            disabled={isSubmitting || isLoading}
            type="submit"
            onClick={handleSubmit}
          >
            Se connecter
          </Button>
          <Link
            className="font-semibold self-start mt-4 text-primary "
            to="/auth/forgot-password"
          >
            <span className="underline decoration-primary/50">
              Mot de passe oublié
            </span>
            <span> ? </span>
          </Link>
          <div className="mt-4 w-full h-0.5 bg-secondary" />
          <div className="mt-4 text-center">
            Vous n&apos;avez pas encore de compte ? Créez-en un rapidement
          </div>
          <Link
            to="/auth/register"
            className="font-semibold text-primary underline decoration-primary/50"
          >
            Inscription
          </Link>
        </form>
      </div>
      <img
        className="hidden md:block w-1/2 h-full object-cover"
        src="/assets/images/auth-banner.jpg"
      />
    </div>
  );
};

export default Login;
